module.exports = __webpack_public_path__ + "img/photo-3-mob.2638b5d5.png";